export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '2d9406ce-b646-45af-832c-bedbfc412a06',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'smmilecare.alares',

  /**
  * Nombre de la app
  */
  appName: 'sMMile Care',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-84CYTH0D4S',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: false,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: true,
  
  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'es',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Alares',
   
   /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'alares'
};
